import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UrlService} from '@shared/services/url.service';
import {Observable} from 'rxjs';
import {API_ENTITY_ASSET_TRANSACTIONS, API_ENTITY_ASSETS} from '../../../config/urls';
import {EntityAssetListDto} from '@dto/holdings/entity-asset-list.dto';
import {EntityAssetTransactionListDto} from '@dto/holdings/entity-asset-transaction-list.dto';

@Injectable({
  providedIn: 'root'
})
export class EntityAssetService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getEntityAssets(entityCode: string): Observable<EntityAssetListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_ASSETS, entityCode);
    return this.http.get<EntityAssetListDto>(endpointUrl);
  }

  public getEntityAssetTransactions(entityCode: string, entityAssetId: string): Observable<EntityAssetTransactionListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_ASSET_TRANSACTIONS, entityCode, entityAssetId);
    return this.http.get<EntityAssetTransactionListDto>(endpointUrl);
  }
}
